<template>
  <div class="base-table spacey-12">
    <div class="table-header project-tenders-columns grey-500 text-sm">
      <div>{{ $t('Tender') }} | {{ $t('Offers deadline') }}</div>
      <div>{{ $t('Representative ') }}</div>
      <div>{{ $t('Offers') }} | {{ $t('Companies') }}</div>
      <div>{{ $t('Attached files') }}</div>
      <div></div>
    </div>
    <Spinner v-if="!savedTenders.length" size="30" />
    <div v-else>
      <TenderRow
        v-for="tender in activeTenders"
        :key="tender.id"
        :tender="tender"
        @archive="handleArchive(tender)"
        @invite="$emit('invite', tender.id)"
        @show-files="showFiles(tender.files)"
      />
      <template v-if="archivedTenders.length">
        <button
          class="show-archived-button grey-500 text-sm vertical-centering"
          @click="changeArchivedDisplay"
        >
          {{ $t('Show archived tenders') }} <ChevronIcon :class="{ 'turn-over': showArchived }" />
        </button>
        <template v-if="showArchived">
          <TenderRow
            v-for="tender in archivedTenders"
            :key="tender.id"
            :tender="tender"
            @unarchive="handleUnarchive(tender)"
            @show-files="showFiles(tender.files)"
          />
        </template>
      </template>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import AttachedFilesModal from '@/components/files/AttachedFilesModal';
  import editTender from '@/utils/mixins/edit-tender';
  import factory from '@/utils/api/factory';
  import TenderRow from '@/components/projects/TenderRow';
  import TENDER_STATUSES from '@/utils/constants/tender-statuses';
  import ChevronIcon from '@/assets/icons/chevron-down.svg';
  import Spinner from 'vue-simple-spinner';

  export default {
    name: 'ProjectCardTenders',
    mixins: [editTender],
    components: {
      TenderRow,
      ChevronIcon,
      Spinner,
    },
    props: {
      tenders: {
        type: Array,
        required: true,
      },
    },
    data() {
      return {
        showArchived: false,
        savedTenders: [],
      };
    },
    watch: {
      tenders(value) {
        this.savedTenders = value;
      },
    },
    computed: {
      ...mapState('global', ['tenderStatuses']),
      activeTenders() {
        return this.tenders.filter((tender) => tender.status !== TENDER_STATUSES.archived);
      },
      archivedTenders() {
        return this.savedTenders.filter((tender) => tender.status === TENDER_STATUSES.archived);
      },
    },
    methods: {
      ...mapActions({
        openModal: 'modal/openModal',
        confirm: 'confirmModal/openModal',
      }),
      showFiles(files) {
        this.openModal({
          component: AttachedFilesModal,
          context: {
            files,
          },
        });
      },
      handleArchive(tender) {
        this.confirm({
          title: `${this.$t('Are you sure you want to archive')} ”${
            tender.name || this.$t('tender')
          }”?`,
          description: this.$t(
            `All tender data will be saved, but you will not be able to invite new bidders. All contractors will receive a notice.`
          ),
          actionText: this.$t('Archive tender'),
          style: 'danger',
          action: async () => {
            try {
              await factory('tenders').postInResourcePath(tender.id, 'archive');
              tender.status = this.tenderStatuses.archived;
            } catch (e) {
              console.error(e);
            }
          },
        });
      },
      handleUnarchive(tender) {
        this.confirm({
          title: `${this.$t('Are you sure you want to unarchive')} ”${
            tender.name || this.$t('tender')
          }”?`,
          actionText: this.$t('Unarchive tender'),
          style: 'danger',
          action: async () => {
            try {
              await factory('tenders').postInResourcePath(tender.id, 'unarchive');
              tender.status = this.tenderStatuses.active;
            } catch (e) {
              console.error(e);
            }
          },
        });
      },
      changeArchivedDisplay() {
        this.showArchived = !this.showArchived;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .show-archived-button {
    left: 5px;
    position: relative;
  }
</style>
